/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
export default {
  yellow_10: '#fcf1dc',
  yellow_20: '#fce4b6',
  yellow_30: '#fad48e',
  yellow_40: '#f7c868',
  yellow_50: '#f0b241',
  yellow_60: '#e3a322',
  yellow_70: '#d19411',
  yellow_80: '#bd8308',
  yellow_90: '#a67305',
  yellow_100: '#916504',

  a11y_text_light: [100]
};



// WEBPACK FOOTER //
// ./src/colors/yellow.js